/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from "react";
import {Table, Tooltip, Button, Input, Space} from "antd";
import FormSearchFilter from "../../components/FormSearchFilter";
import moment from "moment";
import APIService from "../../service/APIService";
import { priceFormat, isCSKH } from "../../utils";
import { useSelector } from "react-redux";
import {SearchOutlined} from "@ant-design/icons";
import Highlighter from "react-highlight-words";

export default function PaymentMomoDuyetPage() {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [filterText, setFilterText] = useState('');
  const [filterColumn, setFilterColumn] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleFilter = async (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys[0]) {
      setFilterText(selectedKeys[0]);
      setFilterColumn(dataIndex);
      setCurrentPage(1);
    }
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
    setFilterText('');
    setCurrentPage(1);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (<div
      style={{
        padding: 8,
      }}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Input
        ref={searchInput}
        placeholder={`nhập ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
        style={{
          marginBottom: 8, display: 'block',
        }}
      />
      <Space>
        <Button
          size="small"
          onClick={() => handleFilter(selectedKeys, confirm, dataIndex)}
        >
          Lọc tất cả
        </Button>
        <Button
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          size="small"
          disabled={!!!dataTable.length}
        >
          Lọc trong trang
        </Button>
        <Button
          type={'link'}
          onClick={() => clearFilters && handleReset(clearFilters)}
          size="small"
          style={{
            width: 90,
          }}
        >
          Khôi phục
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            close();
          }}
        >
          đóng
        </Button>
      </Space>
    </div>), filterIcon: (filtered) => (<SearchOutlined
      style={{
        color: filtered ? '#1677ff' : undefined,
      }}
    />), onFilter: (value, record) => {
      //console.log(value, record[dataIndex])
      return record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
    }, onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    }, render: (text) => searchedColumn === dataIndex ? (<Highlighter
      highlightStyle={{
        backgroundColor: '#ffc069', padding: 0,
      }}
      searchWords={[searchText]}
      autoEscape
      textToHighlight={text ? text.toString() : ''}
    />) : (text),
  });

  const [dataTable, setDataTable] = useState([]);
  const [filter] = useState({});
  const user = useSelector((state) => state.user.userState);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      width: 140,
      key: "id",
    },

    {
      title: "USER",
      dataIndex: "player",
      width: 140,
      key: "player",
      ...getColumnSearchProps("player")
    }, {
      title: "USERNAME", dataIndex: "username", width: 200, key: "username", ...getColumnSearchProps("username")
    },

    {
      title: "SDT",
      dataIndex: "sdt",
      width: 140,
      key: "sdt",
    },

    {
      title: "MỆNH GIÁ",
      dataIndex: "menhGia",
      width: 160,
      key: "menhGia",
      render: (data) => priceFormat(data),
    },
    {
      title: "CHI TIẾT",
      dataIndex: "detail",
      key: "detail",
      width: 250,
      ellipsis: {
        showTitle: false,
      },
      render: (data) => (
        <Tooltip placement="topLeft" title={data}>
          {data}
        </Tooltip>
      ),
    },
    {
      title: "MÃ GIAO DỊCH",
      dataIndex: "orderid",
      width: 180,
      key: "orderid",
      ...getColumnSearchProps("orderid")
    },
    {
      title: "NGƯỜI GỬI",
      dataIndex: "sender",
      width: 140,
      align: "center",
      key: "sender",
    },
    {
      title: "TRẠNG THÁI",
      dataIndex: "status",
      width: 140,
      align: "center",
      key: "status",
      render: (data) => {
        switch (data) {
          case 0:
            return <p className="text-green-400	font-semibold">Chờ duyệt</p>;
          case 1:
            return <p className="text-green-400	font-semibold">Thành công</p>;
          case 2:
            return <p className="text-black-400	font-semibold">Không duyệt</p>;
          case 3:
            return <p className="text-black-400	font-semibold">Chờ cổng</p>;
          default:
            return <p className="text-green-400	"></p>;
        }
      },
    },

    {
      title: "DUYỆT TAY",
      dataIndex: "duyetTay",
      width: 140,
      align: "center",
      key: "duyetTay",
      render: (data) => {
        switch (data) {
          case -1:
            return <p className="text-red-400	font-semibold">Lỗi</p>;
          case 0:
            return <p className="text-green-400	font-semibold">Bình thường</p>;
          case 1:
            return <p className="text-green-400	font-semibold">Thành công</p>;
          case 2:
            return <p className="text-black-400	font-semibold">Không duyệt</p>;
          case 3:
            return <p className="text-black-400	font-semibold">Chờ duyệt</p>;
          default:
            return <p className="text-green-400	"></p>;
        }
      },
    },

    {
      title: "CẬP NHẬT LÚC",
      dataIndex: "updatedAt",
      width: 140,
      key: "updatedAt",
      align: "center",
      render: (data, data1, index) => (
        <p>{moment(data).format("DD-MM-YYYY HH:mm:ss")}</p>
      ),
    },
    {
      title: "DUYỆT",
      dataIndex: "",
      key: "",
      align: "center",
      width: 250,
      render: (data, data1, index) => {
        if (data1.duyetTay === 3 && data1.activeApprove === true) {
          return (
            <>
              <Button
                className="text-center"
                type="primary"
                onClick={() => {
                  confirmMoMo(data1.orderid, 1);
                }}
              >
                Duyệt
              </Button>
              &nbsp;
              <Button
                className="text-center"
                type="primary"
                onClick={() => {
                  confirmMoMo(data1.orderid, 0);
                }}
              >
                Không Duyệt
              </Button>
            </>
          );
        } else return "";
      },
    },
    {
      title: "ĐỔI TRẠNG THÁI",
      dataIndex: "",
      key: "",
      align: "center",
      width: 450,
      render: (data, data1, index) => {
        if (data1.duyetTay === 3) {
          return (
            <>
              <Button
                className="text-center"
                type="primary"
                onClick={() => {
                  changeMoMoStatus(data1.orderid, 1);
                }}
              >
                Thành Công
              </Button>
              &nbsp;
              <Button
                className="text-center"
                type="primary"
                onClick={() => {
                  changeMoMoStatus(data1.orderid, 0);
                }}
              >
                Thất Bại
              </Button>
              &nbsp;
              <Button
                className="text-center"
                type="primary"
                onClick={() => {
                  changeSunStatus(data1.orderid);
                }}
              >
                Rút từ Sun
              </Button>
              &nbsp;
              <Button
                className="text-center"
                type="primary"
                onClick={() => {
                  changeHitStatus(data1.orderid);
                }}
              >
                Rút từ Sun
              </Button>
            </>
          );
        } else return "";
      },
    },
  ];

  async function getPaymentMomoDuyetList(filter = {}, page = 1, size = 10) {
    try {
      let wherePlayerId = "";
      let filterWhere = [];
      if (filter["player"]) {
        wherePlayerId = ` player like '%${filter["player"]}%'`;
        filterWhere.push(wherePlayerId);
      }
      if (filter["orderid"]) {
        wherePlayerId = ` orderid like '%${filter["orderid"]}%'`;
        filterWhere.push(wherePlayerId);
      }

      if (filter['username']) {
        const listUser = await APIService.searchUserInfo("", filter['username']);
        if (Array.isArray(listUser)) {
          const userids = listUser.map(i => i['userid']).join("','");

          filterWhere.push(` player IN('${userids}') `);
        } else {
          return setDataTable([]);
        }
      }

      const data = await APIService.paymentMomoDuyetList(filterWhere.join(" AND "), page, size);

      if (data) {
        for (let i = 0; i < data.length; i++) data[i].activeApprove = true;
        // cskh chỉ cho phép xem trong n ngày gần nhất
        if (isCSKH(user)) {
          let to = new Date();
          to.setHours(23);
          to.setMinutes(59);
          to.setSeconds(59);
          let from = new Date();
          from.setDate(
            to.getDate() - process.env.REACT_APP_LIMIT_CSKH_DATE_NUMBER
          );
          from.setHours(0);
          from.setMinutes(0);
          from.setSeconds(0);
          for (let i = 0; i < data.length; i++) {
            // không cho phép duyệt mệnh giá từ 1tr
            if (data[i].menhGia >= 1500000) data[i].activeApprove = false;
            let createdDate = moment(data[i].timestamp);
            let limitDate = moment(from);
            if (createdDate.isBefore(limitDate)) {
              data.splice(i, 1);
              i--;
            }
          }
        }
        setDataTable(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function confirmMoMo(orderid, type) {
    try {
      let text = "Bạn có muốn DUYỆT giao dịch momo này không ?";
      if (type === 0)
        text = "Bạn có muốn KHÔNG DUYỆT giao dịch momo này không ?";
      if (window.confirm(text) === true) {
        const data = await APIService.confirmMoMo(orderid, type);
        if (data) {
          getPaymentMomoDuyetList({
            [filterColumn]: filterText
          }, currentPage, pageSize).then();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function changeMoMoStatus(orderid, status) {
    try {
      let text =
        "Bạn có muốn chuyển trạng thái THÀNH CÔNG giao dịch momo này không ?";
      if (status === 0)
        text =
          "Bạn có muốn chuyển trạng thái THẤT BẠI giao dịch momo này không ?";
      if (window.confirm(text) === true) {
        const data = await APIService.changeMoMoStatus(orderid, status);
        if (data) {
          getPaymentMomoDuyetList({
            [filterColumn]: filterText
          }, currentPage, pageSize).then();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function changeSunStatus(orderid) {
    try {
      let text =
        "Bạn có muốn chuyển trạng thái RÚT TỪ SUN giao dịch momo này không ?";
      if (window.confirm(text) === true) {
        const data = await APIService.changeSunStatus(orderid);
        if (data) {
          getPaymentMomoDuyetList({
            [filterColumn]: filterText
          }, currentPage, pageSize).then();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function changeHitStatus(orderid) {
    try {
      let text =
        "Bạn có muốn chuyển trạng thái RÚT TỪ HIT giao dịch momo này không ?";
      if (window.confirm(text) === true) {
        const data = await APIService.changeHitStatus(orderid);
        if (data) {
          getPaymentMomoDuyetList({
            [filterColumn]: filterText
          }, currentPage, pageSize).then();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  function onChangePage(page, _pageSize) {
    if (_pageSize !== pageSize) {
      setPageSize(_pageSize)
      setCurrentPage(1);
    } else if (page !== currentPage) {
      setCurrentPage(page)
    }
  }

  useEffect(() => {
    getPaymentMomoDuyetList({
      [filterColumn]: filterText
    }, currentPage, pageSize).then();
  }, [currentPage, pageSize, filterText]);

  return (
    <>
      <FormSearchFilter
        title="Duyệt Momo"
        initialValues={filter}
      ></FormSearchFilter>
      <Table columns={columns} dataSource={dataTable} pagination={{
        position: ['top'],
        total: 1000,
        current: currentPage,
        onChange: onChangePage,
        defaultCurrent: 1,
        pageSize: 20
      }}/>
    </>
  );
}
